import { render } from "./ModuleContainer.vue?vue&type=template&id=bc8992a8"
import script from "./ModuleContainer.vue?vue&type=script&lang=js"
export * from "./ModuleContainer.vue?vue&type=script&lang=js"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__